<script setup lang="ts">
import { usePublicPage } from "@/api/public-page-query";
import NotFound from "@/components/common/NotFound.vue";
import PublicPagesSettings from "@/components/public-pages/PublicPagesSettings.vue";
import { mdiChevronDoubleLeft } from "@mdi/js";
import { Icon, LinkButton } from "@soft-db/ui";

const { t } = useI18n();

const route = useRoute();

const id = computed(() => route.params.id as string);
const { publicPage, error } = usePublicPage(() => (route.params.pageid || "") as string);
</script>

<template>
	<div>
		<div class="pb-4">
			<LinkButton variant="outline" :to="{ name: 'distributor-id', params: { id } }">
				<Icon :d="mdiChevronDoubleLeft" />
				<span>{{ t("distributor.goBack") }}</span>
			</LinkButton>
		</div>
		<NotFound v-if="error" :page="t('object.publicPage')" />
		<PublicPagesSettings v-else-if="publicPage" :page="publicPage" />
	</div>
</template>
